import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useMutation } from "@tanstack/react-query";
import { useContext,useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { UserContext } from "../../context/UserContext";
import AttToken from "../../helpers/attToken";
import { trackEventMatomo } from "../../helpers/matomo";
import Companies from "../../service/Companies";
import { Form } from "../../StyledComponents/Input/generic";

const empresaService = new Companies();

export default function Permissions() {
  const { userData, saveUserData } = useContext(UserContext);
  const [autoriza, setAutoriza] = useState<boolean>(userData.concedeAcesso);
  const { t } = useTranslation('translation');

  const { mutate, isPending } = useMutation({
    mutationKey: ['SET_PERMISSION'],
    mutationFn: async (nextAutoriza: boolean) => {
      const token = await AttToken();
      if (!token) throw new Error('Token not found');

      return toast.promise(
        (async () => {
          const res = await empresaService.concedeRetiraPermissaoLogin(
            token,
            token.userEmpresa,
            nextAutoriza
          );

          if (!res || typeof res === 'number' || res.error) {
            throw new Error('Error saving permission');
          }

          return res;
        })(),
        {
          pending: `${t('settingsPage.saving')}`,
          success: `${t('settingsPage.saved')}`,
          error: `${t('settingsPage.errorSaving')}`,
        },
        { toastId: 'saving-permission' }
      );
    },
    onSuccess: (_data, nextAutoriza) => {
      trackEventMatomo('permissões', 'sucesso', 'salvamento', nextAutoriza ? 'acesso de suporte concedido' : 'acesso de suporte revogado');
      const atualizado = { ...userData, concedeAcesso: nextAutoriza };
      saveUserData(atualizado);
    },
    onError: (err) => {
      trackEventMatomo('permissões', 'erro', 'salvamento', 'falha ao alterar acesso de suporte');
      throw new Error((err as Error).message);
    },
  });

  return (
    <Form style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'gray', fontWeight: 600, fontSize: '12px' }}>
      <Button
        variant="contained"
        color={autoriza ? "error" : "success"}
        style={{ marginBottom: '10px' }}
        disabled={isPending}
        onClick={(event) => {
          trackEventMatomo('permissões', 'click', 'button', 'concede acesso suporte');
          event.preventDefault();

          const nextAutoriza = !autoriza;
          setAutoriza(nextAutoriza);
          mutate(nextAutoriza);
        }}
      >
        {autoriza ? t('settingsPage.revokeAccess') : t('settingsPage.grantAccess')}
      </Button>
      {!autoriza ? (
        <Typography fontWeight="bold" variant="h6" color="textDisabled">
          {t('settingsPage.grantLoginAccessToSupport')}
        </Typography>
      ) : (
        <Typography fontWeight="bold" variant="h6" color="textDisabled">
          {t('settingsPage.revokeLoginAccessToSupport')}
        </Typography>
      )}

    </Form>
  );
}
